import { compose } from 'redux';
import { connect } from 'react-redux';
import MazeModelScrollView from '../modelScroll/MazeModelScrollView';
import selectors from '../../../rootSelectors';
import { setMazeScreenMode } from '../../mazeActions';
import withAvatar from '../../../common/avatar/withAvatar';
import { stopAudio } from '../../../common/audio/audioActions';
import {
    blockScreen,
    unblockScreen,
    unmountScreen,
    activateNextButton,
} from '../../../common/screen/screenActions';
import { goToCountdown } from '../../../common/navigation/navigationActions';
import { SCROLL, MODE } from '../../../constants/assessmentItemType';
import { highlightCorrectResponses } from '../modelScroll/MazeModelScrollActions';
import { narrateReadyScript } from './MazeInstructionsActions';
import { NO_SCROLL_ANIMATION_DURATION } from '../../../constants/slider';
import AvatarView from '../../../common/avatar/avatarView';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';

const mapStateToProps = (state, ownProps) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDataFetched: selectors.getIsMazeDataFetched(state),
    isDownButtonHighlighted: selectors.getIsDownButtonHighlighted(state),
    isScrollButtonClicked: selectors.getIsScrollButtonClicked(state),
    isOkButtonGreyedOut: selectors.getIsOkButtonGreyedOut(state),
    paragraphs: selectors.getMazeParagraphs(state, SCROLL),
    questions: selectors.getMazeQuestionItems(state, SCROLL),
    title: selectors.getMazeTitle(state, SCROLL),
    selectedResponses: selectors.getMazeSelectedResponses(state),
    screenMode: selectors.getMazeScreenMode(state),
    scrollDuration: NO_SCROLL_ANIMATION_DURATION,
    isExtendedView: ownProps.isExtendedView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchContent: () => {
        dispatch(ownProps.flowStrategy.fetchContent());
        dispatch(setMazeScreenMode(MODE.READY));
    },
    initModelScrollScreen: () => {
        dispatch(highlightCorrectResponses());
    },
    readyScript: () => {
        dispatch(blockScreen());
        dispatch(activateNextButton());
        return dispatch(narrateReadyScript(ownProps.flowStrategy.instructions[SCROLL])).then(() => {
            dispatch(unblockScreen());
        });
    },
    onNext: () => {
        dispatch(goToCountdown(ownProps.flowStrategy.assessment));
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(unmountScreen());
    },
});

// memorize instructions array to prevent re-rendering
let instructions;
const getInstructions = scrollInstructions => {
    if (instructions === undefined) {
        instructions = [
            scrollInstructions.scrollInstruction,
            scrollInstructions.scrollReadyClickOk,
        ];
    }
    return instructions;
};

const avatarMapStateToProps = (_, ownProps) => {
    const { isExtendedView } = ownProps;
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        extendedViewPosition: AvatarView.Position.LOWER_FAR_LEFT,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig, isExtendedView);
    return {
        position,
        instructions: getInstructions(ownProps.flowStrategy.instructions[SCROLL]),
        animateAlex: true,
    };
};

const MazeInstructionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MazeModelScrollView);

export default MazeInstructionsContainer;
